import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * Recebe o token de suporte na URL (?token=...&slug=...), armazena em
 * sessionStorage (isolado por aba) e navega para o ambiente do tenant.
 * A URL do token nunca fica persistida em histórico "logável" porque removemos
 * imediatamente após consumo.
 */
export default function SupportEnter() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = params.get("token");
    const slug = params.get("slug");
    if (!token || !slug) {
      nav("/super/clientes", { replace: true });
      return;
    }
    sessionStorage.setItem("flr_support_token", token);
    // Dispara reload do AuthContext para carregar /support/me
    setTimeout(() => {
      window.location.replace(`/${slug}/fila`);
    }, 100);
  }, [params, nav]);
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-sm uppercase tracking-widest text-gray-400">Entrando em modo suporte…</div>
    </div>
  );
}
